import { style } from 'typestyle'
export const textCenter = style({ textAlign: 'center' })
